import { Column } from "../../cms/objects/column";
import { ClientDemandListConfiguration, ClientDemandListCriteria, ClientDemandListFiltersCriteria } from "../objects/clientDemand";

export const EMPTY_CLIENT_DEMAND_FILTERS: ClientDemandListFiltersCriteria = {
    status: [],
    cms: null,
    creator: '',
    last_author: '',
    created_date_gte: null,
    created_date_lte: null,
    modified_date_gte: null,
    modified_date_lte: null,
    period_type: 0,
    period: 'MODIFICATION',
};

export const EMPTY_CLIENT_DEMAND_LIST_CRITERIA: ClientDemandListCriteria = {
    limit: 50,
    page: 0,
    search: '',
    filters: EMPTY_CLIENT_DEMAND_FILTERS,
    order: 'asc',
    order_by: '',
};

export const CLIENT_DEMAND_DEFAULT_COLUMNS: Column[] = [
    {
        label: 'status',
        field_name: 'STATUS',
        checked: true,
        order_by: 'status',
        fixed_width: false,
        last_updated: false,
    },
    {
        label: 'name',
        field_name: 'NAME',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false,
    },
    {
        label: 'cms',
        field_name: 'CMS',
        checked: true,
        order_by: 'cms__name',
        fixed_width: false,
        last_updated: false,
    },
    {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: true,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false,
    },
    {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false,
    },
    {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false,
    },
    {
        label: 'address',
        field_name: 'ADDRESS',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false,
    },
];

export const EMPTY_CLIENT_DEMAND_LIST_CONFIGURATION: ClientDemandListConfiguration = {
    columns: CLIENT_DEMAND_DEFAULT_COLUMNS,
    preferences: [],
};

export const CLIENT_DEMAND_MODULE = 'CLIENT_DEMAND';
